<template>
	<section :id="['container-' + index + '-' + unitListData.type]" :class="['container-' + unitListData.type]">
		<div class="container-lg facts-table">
			<div class="row">
                <div class="col-md-12">
                    <h2 v-if="unitListData.config.title">{{ unitListData.config.title }}</h2>
                </div>	
				<div class="col-12">
					<template v-for="(units, index) in unitListData.config.tableBody" :key="index">
						<div class="unit-list">
							<div class="row" >
								<template v-for="(unitBody, indexBody) in unitListData.config.tableBody[index]" :key="indexBody">
									<div class="col-xl-2 col-md-3 col-6 table-column" v-if="unitBody !== '' && unitBody !=='Nein' && unitBody !=='keine Angabe' && unitBody != '-'">
										<div class="row">
											<div class="table-body">
												<span class="unit-data">{{ unitBody }}</span>
											</div>
											<template v-for="(unitHeader, indexHeader) in unitListData.config.tableHeader" :key="indexHeader">
												<div class="table-header" v-if="indexHeader == indexBody">
													<span class="unit-data-name">{{ unitHeader }}</span>
												</div>
											</template>
										</div>
									</div>
								</template>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<hr class="horizontal-line">
	</section>
</template>

<script>

export default {
	props: {
		unitListData: {
			type: Object
		},
		index: {
			type: Number
		},
	}
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/unitListComponent.scss";
</style>;